<template>
<div class="register-box justify-content-center">
    <div class="register-box-body">
        <form class="form-group" @submit.prevent="register">
            <div class="row">
                <div class="col col-12">
                    <div class="form-group select-wrapper">
                        <select 
                            name="salutation" 
                            class="form-control col-xxl-12 col-form-label" 
                            id="salutation" 
                            v-model="registerForm.salutation"
                            required>
                            <option disabled="disabled" value="">{{ $t('register.salutation.select') }}</option>
                            <option value="mr">{{ $t('register.salutation.mr') }}</option>
                            <option value="mrs">{{ $t('register.salutation.mrs') }}</option>
                            <option value="diverse">{{ $t('register.salutation.diverse') }}</option>
                            <option value="none">{{ $t('register.salutation.none') }}</option>
                        </select>
                        <span class="fa fa-user form-control-feedback symbol-input"></span>
                        <HasError :form="registerForm" field="salutation"></HasError>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-xxl-6 col-12">
                    <div class="form-group">
                        <input class="col-xl-12 col-form-label"
                               type="text"
                               name="first_name"
                               required
                               autocomplete="given-name"
                               v-model="registerForm.first_name"
                               :placeholder="$t('register.first_name')">
                        <span class="fa fa-user form-control-feedback symbol-input"></span>
                        <HasError :form="registerForm" field="first_name"></HasError>
                    </div>
                </div>
                <div class="col col-xxl-6 col-12">
                    <div class="form-group">
                        <input class="col-md-12 col-form-label required"
                               type="text"
                               name="last_name"
                               autocomplete="family-name"
                               required
                               v-model="registerForm.last_name"
                               :placeholder="$t('register.last_name')">
                        <span class="fa fa-user form-control-feedback symbol-input"></span>
                        <HasError :form="registerForm" field="last_name"></HasError>
                    </div>
                </div>
            </div>
            
            <div class="form-group">
                <input class="col-md-12 col-form-label"
                       type="email"
                       name="email"
                       autocomplete="email"
                       required
                       :pattern="email_pattern"
                       v-model="registerForm.email"
                       :placeholder="$t('register.email')">
                <span class="fa fa-envelope form-control-feedback symbol-input"></span>
                <HasError :form="registerForm" field="email"></HasError>
                <div v-if="form_data.enabled" :name="`${form_data.nameFieldName}_wrap`" style="display:none;">
                    <input type="text" v-model="registerForm[form_data.nameFieldName]" :name="form_data.nameFieldName" :id="form_data.nameFieldName" />
                    <input type="text" v-model="registerForm[form_data.validFromFieldName]" :name="form_data.validFromFieldName" />
                </div>
            </div>
            <div class="row">
                <div class="col col-xxl-6 col-12">
                    <div class="form-group">
                        <input class="col-md-12 col-form-label"
                               type="password" name="password"
                               autocomplete="new-password"
                               required
                               v-model="registerForm.password"
                               :placeholder="$t('register.password')">
                        <span class="fa fa-lock form-control-feedback symbol-input"></span>
                        <HasError :form="registerForm" field="password"></HasError>
                    </div>
                </div>
                <div class="col col-xxl-6 col-12">
                    <div class="form-group">
                        <input class="col-md-12 col-form-label"
                               type="password"
                               name="password_confirmation"
                               v-model="registerForm.password_confirmation"
                               autocomplete="new-password"
                               required
                               :placeholder="$t('register.password_confirm')">
                        <span class="fa fa-lock form-control-feedback symbol-input"></span>
                        <HasError :form="registerForm" field="password_confirmation"></HasError>
                    </div>
                </div>
            </div>
            
            <div class="form-group ">
                <input 
                    class="col-md-12 col-form-label" 
                    type="checkbox" 
                    name="accept_policy_disclosure" 
                    id="accept_policy_disclosure" 
                    required="required"
                    v-model="registerForm.accept_policy_disclosure">
                <label for="accept_policy_disclosure">
                    {{ $t('register.accept_policy_disclosure.pt1') }}
                    <a v-on:click="$popup.open($event,$t('register.accept_policy_disclosure.file'))"> {{ $t('register.accept_policy_disclosure.linktext1') }}</a>
                    {{ $t('register.accept_policy_disclosure.pt3') }}
                </label>
            </div>
            
            <div class="form-group ">
                <input 
                    class="col-md-12 col-form-label" 
                    type="checkbox" 
                    name="accept_tos_agreement" 
                    id="accept_tos_agreement" 
                    required="required"
                    v-model="registerForm.accept_tos_agreement">
                <label for="accept_tos_agreement">
                    {{ $t('register.accept_tos_agreement.pt1') }}
                    <a v-on:click="$popup.open($event,$t('register.accept_tos_agreement.file'))">{{ $t('register.accept_tos_agreement.linktext1') }}</a>
                </label>
            </div>

            <button type="submit" class="btn btn-secondary btn-block slide-btn">
                {{ $t('register.register') }}
            </button>
        </form>
        <div class="text-center w-full">
            <p>
                <router-link :to="{name: 'login'}" class="txt1">
                    <i class="fa fa-long-arrow-left"></i>&nbsp;{{ $t('login.sign_in2') }}
                </router-link>
            </p>
        </div>
    </div>
</div>
</template>

<script>
    import _ from 'lodash';
    export default {
        name: 'Register',
        props: {
            template: String
        },
        data() {
            return {
//                accept_policy_disclosure: false,
//                accept_tos_agreement: false,
                registerForm: new Form({
                    salutation: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    accept_policy_disclosure: false,
                    accept_tos_agreement: false
                })
            };
        }
        , components:{

        }
        , created() {

        }
        , mounted() {
//            console.log('Register.vue');
        }
        ,computed:{
            form_data(){
                return window.form_data;
            }
        }
        , methods: {
            register(){
//                console.log('on submit register');
                let url = '/register';
                this.registerForm.lang = window.langKey;
                this.registerForm.post(url)
                .then(response => {
                    if(response.status === 200 || response.status === 201){
                        this.message = response.data.message;
                        this.$router.push({ name: 'email_verify'});
                    }
                }).catch(function (error) {
                    
                });
            }
        }
    }
</script>